import { useEffect, useRef } from 'react';

interface GoogleIdentity {
  accounts: { id: {
    initialize: (o: { client_id: string; ux_mode: 'redirect'; login_uri: string; auto_select?: boolean }) => void;
    renderButton: (el: HTMLElement, o: Record<string, string | number>) => void;
  } };
}
declare global { interface Window { google?: GoogleIdentity } }

const SCRIPT = 'https://accounts.google.com/gsi/client';
let loading: Promise<void> | null = null;
function loadScript() {
  loading ??= new Promise<void>((resolve, reject) => {
    if (window.google?.accounts) return resolve();
    const s = document.createElement('script');
    s.src = SCRIPT; s.async = true; s.defer = true;
    s.onload = () => resolve();
    s.onerror = () => { loading = null; reject(new Error('não foi possível carregar o Google')); };
    document.head.appendChild(s);
  });
  return loading;
}

/**
 * Botão "Entrar com Google" (Google Identity Services), no fluxo de página inteira: a pessoa vai ao Google e volta
 * já dentro, sem janela. O Google entrega o ID token em `/auth/google/callback` (neste mesmo endereço, que o proxy
 * leva para a API). Quem decide o acesso é a API: só entra quem já tem conta com o mesmo e-mail.
 * `tone`: escuro na machine, claro no MODO.
 */
export function GoogleButton({ clientId, onError, tone = 'dark', width = 320 }: { clientId: string; onError?: (message: string) => void; tone?: 'dark' | 'light'; width?: number }) {
  const el = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let alive = true;
    loadScript().then(() => {
      if (!alive || !el.current || !window.google) return;
      window.google.accounts.id.initialize({ client_id: clientId, ux_mode: 'redirect', login_uri: `${window.location.origin}/auth/google/callback`, auto_select: false });
      window.google.accounts.id.renderButton(el.current, { type: 'standard', theme: tone === 'dark' ? 'filled_black' : 'outline', size: 'large', shape: tone === 'dark' ? 'rectangular' : 'pill', text: tone === 'dark' ? 'signin_with' : 'continue_with', logo_alignment: tone === 'dark' ? 'left' : 'center', locale: 'pt-BR', width });
    }).catch((e: Error) => onError?.(e.message));
    return () => { alive = false; };
  }, [clientId, onError, tone, width]);
  return <div ref={el} className="rr-google" />;
}
